import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    min-height: 100vh;
    background: linear-gradient(135deg, var(--sl-color-primary-50) 0%, var(--sl-color-primary-100) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .login-container {
    width: 100%;
    max-width: 400px;
  }

  .login-card {
    background: white;
    border-radius: var(--sl-border-radius-large);
    box-shadow: var(--sl-shadow-x-large);
    padding: 2.5rem;
    border: 1px solid var(--sl-color-neutral-200);
  }

  .login-header {
    text-align: center;
    margin-bottom: 2rem;
  }

  .login-header sl-icon {
    color: var(--sl-color-primary-600);
    margin-bottom: 1rem;
  }

  .login-header h2 {
    margin: 0 0 0.5rem 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.75rem;
    font-weight: 600;
  }

  .login-header p {
    margin: 0;
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
  }

  .login-form {
    margin-bottom: 2rem;
  }

  .form-group {
    margin-bottom: 1.5rem;
  }

  .form-group sl-input {
    width: 100%;
  }

  .form-group.remember-me {
    margin-bottom: 1rem;
    margin-top: -0.5rem;
  }

  .form-group.remember-me sl-checkbox {
    font-size: 0.875rem;
    color: var(--sl-color-neutral-700);
  }

  .form-actions {
    margin-top: 2rem;
  }

  .login-button {
    width: 100%;
    height: 3rem;
    font-weight: 600;
  }

  .login-footer {
    border-top: 1px solid var(--sl-color-neutral-200);
    padding-top: 1.5rem;
    text-align: center;
  }

  .login-footer p {
    margin: 0 0 1rem 0;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
    font-weight: 500;
  }

  .demo-credentials {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .credential-item {
    font-size: 0.75rem;
    color: var(--sl-color-neutral-600);
    background: var(--sl-color-neutral-50);
    padding: 0.5rem;
    border-radius: var(--sl-border-radius-small);
    border: 1px solid var(--sl-color-neutral-200);
  }

  .credential-item strong {
    color: var(--sl-color-neutral-800);
  }

  /* Responsive design */
  @media (max-width: 480px) {
    .login-card {
      padding: 1.5rem;
    }

    .login-header h1 {
      font-size: 1.5rem;
    }

    .demo-credentials {
      font-size: 0.7rem;
    }
  }

  /* Focus states for accessibility */
  .login-card:focus-within {
    box-shadow: var(--sl-shadow-x-large), 0 0 0 2px var(--sl-color-primary-200);
  }

  /* Animation for card entrance */
  .login-card {
    animation: slideIn 0.3s ease-out;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Session confirmation styles */
  .session-confirmation {
    text-align: center;
  }

  .confirmation-header {
    margin-bottom: 2rem;
  }

  .confirmation-header sl-icon {
    color: var(--sl-color-warning-600);
    margin-bottom: 1rem;
  }

  .confirmation-header h3 {
    margin: 0 0 0.5rem 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.25rem;
    font-weight: 600;
  }

  .confirmation-header p {
    margin: 0;
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
  }

  .existing-session-info {
    background: var(--sl-color-neutral-50);
    border: 1px solid var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    padding: 1rem;
    margin-bottom: 1.5rem;
  }

  .session-details {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .device-icon {
    font-size: 1.5rem;
    line-height: 1;
  }

  .session-text {
    text-align: left;
    flex: 1;
  }

  .device-name {
    font-weight: 600;
    color: var(--sl-color-neutral-800);
    margin-bottom: 0.25rem;
  }

  .last-activity {
    font-size: 0.875rem;
    color: var(--sl-color-neutral-600);
  }

  .confirmation-message {
    margin-bottom: 2rem;
  }

  .confirmation-message p {
    margin: 0;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
    line-height: 1.5;
  }

  .confirmation-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: center;
  }

  .confirmation-actions sl-button {
    flex: 1;
    max-width: 120px;
  }

  /* Error message styles */
  .error-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: var(--sl-color-danger-50);
    color: var(--sl-color-danger-700);
    padding: 0.75rem;
    border-radius: var(--sl-border-radius-medium);
    border: 1px solid var(--sl-color-danger-200);
    margin-bottom: 1rem;
    font-size: 0.875rem;
  }

  .error-message sl-icon {
    color: var(--sl-color-danger-600);
  }
`; 